<template>
  <v-container id="role-view" fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <role-detail v-model="dialog" :role="item" @save="save_role" @clear="clear_role"></role-detail>
        <role-permission v-model="dialog_permission" :role="item" :product_id="product_id"></role-permission>
        <confirmation-delete v-model="confirmDelete" @excluir="excluir_role" ></confirmation-delete>
        <material-card color="primary" title="Lista de Perfis">
            <v-row>
                <v-col cols="4" >
                    <v-text-field v-model="filtro" label="Pesquisa" placeholder="Filtro de pesquisa" append-icon="mdi-magnify" hide-details dense clearable outlined></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog = true" style="margin-right: 1%" :disabled="!hasRole(['ADMIN', 'role:create'])" outlined>
                    <v-icon left>mdi-plus-circle-outline</v-icon>NOVO PERFIL
                </v-btn>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :search="filtro"
                :key="index"
            >
                <template v-slot:item.product_id="{ item }">
                    {{ get_product_name({ id: item.product_id }) }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'permission-role:read'])" v-on="on" @click="edit_permissions(item)">
                                <v-icon color="warning">mdi-apps</v-icon>
                            </v-btn>
                        </template>
                        <span style="color:#FFF">Permissões</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'role:update'])" v-on="on" @click="edit(item)">
                                <v-icon color="primary">mdi-pencil</v-icon>                            
                            </v-btn>
                        </template>
                        <span style="color:#FFF">Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'role:delete'])" :loading="item.loading_remove" v-on="on" @click="remove(item)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span style="color:#FFF">Excluir</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card.vue'
import ConfirmationDelete from '@/components/material/ConfirmationDelete.vue'
import RoleDetail from '@/views/role/Detail.vue'
import RolePermission from '@/views/role/RolePermission.vue'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        dialog: null,
        dialog_permission: null,
        loading: null,
        confirmDelete: null,
        headers: [
            { sortable: true, text: '#', value: 'id', width: '30%' },
            { sortable: true, text: 'Produto', value: 'product_id', width: '25%' },
            { sortable: true, text: 'Nome', value: 'name' },
            { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '20%' }
        ],
        item: {},
        index: 0
    }),
    mounted() {
        this.search()
    },
    components: {
        MaterialCard,
        ConfirmationDelete,
        RoleDetail,
        RolePermission
    },
    computed: {
        ...mapState('role', ['filter', 'roles']),
        ...mapState('product', ['products']),
        ...mapGetters('product', ['get_product_name']),
        ...mapGetters('app', ['hasRole']),
        filtro: {
            get() { return this.filter },
            set(value) { this.SET_FILTER(value) }
        },
        items: {
            get() { return this.roles },
            set(value) { this.SET_ROLES(value) }
        },
        product_id() { return (this.item.product_id || '') }
    },
    methods: {
        ...mapActions('product', { init_product: 'init_select' }),
        ...mapActions('permission', { init_permission: 'init_select' }),
        ...mapActions('role', ['init']),
        ...mapMutations('role', ['SET_FILTER', 'SET_ROLES']),
        async search() {
            this.loading = true
            try {
                await Promise.all([
                    this.init_product(), 
                    this.init_permission(), 
                    this.init()])
            }
            catch(_) { 
                this.loading = false
            }
            finally {
                this.loading = false
            }
        },
        edit(item) {
            this.item = Object.assign({}, item)
            this.dialog = true
        },
        remove(item) {
            this.item = item
            this.confirmDelete = true
        },
        edit_permissions(item) {
            this.item = Object.assign({}, item)
            this.dialog_permission = true
        },
        save_role({ item, isNew }) {
            if (isNew) {
                this.items.push(item)
            }
            else {
                var index = 0
                this.items.forEach(function (c) { 
                    if (c.id == item.id) return ;
                    index++;
                })
                this.items[index] = Object.assign({}, item)
                this.index += 1;
            }
            this.dialog = false
            this.item = {}
        },
        excluir_role() {
            this.confirmDelete = false
            var context = this
            var item = this.items.filter(i => i.id == context.item.id)[0]
            item.loading_remove = true
            this.axios.delete(this.$store.state.url_api + '/role/' + item.id)
                .then(() => {
                    item.loading_remove = false
                    var index = 0
                    context.items.forEach(({ id }) => {
                        if (id == item.id) {
                            context.items.splice(index, 1)
                            return ;   
                        }
                        index++
                    })
                })
                .catch(() => {
                    item.loading_remove = false
                })
            this.item = {}
        },
        clear_role() {
            this.item = {}
        }
    }
}
</script>